<ic-ui-card class="small-header">
	<header>
		<pv-title>
			<ic-fa-icon icon="file-text" />
			<h1>{{ "auth.termsAndConditions.title" | translate }}</h1>
		</pv-title>
	</header>

	<section><ic-terms-conditions-text /></section>

	<footer class="align-right">
		<ui-double-button
			class="decline button"
			icon="fa fa-remove"
			type="secondary"
			[disabled]="accepting"
			(click)="onDecline()"
		>
			{{ "auth.termsAndConditions.decline" | translate }}
		</ui-double-button>
		<ui-double-button
			class="accept button"
			data-test="accept-terms-and-conditions-button"
			type="primary"
			[disabled]="accepting"
			[icon]="accepting ? 'fa fa-circle-o-notch fa-spin' : 'fa fa-check'"
			(click)="onAccept()"
		>
			{{ "auth.termsAndConditions.accept" | translate }}
		</ui-double-button>
	</footer>
</ic-ui-card>
